import React from "react";
import { Link, useLocation } from "react-router-dom";
import LogoutIcon from "../../assets/icons/logout";

const SideMenu = ({ menuItems }) => {
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("user_role");
    window.location = "/";
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-col gap-6 flex-1 overflow-x-auto py-4">
        {menuItems.map(({ path, label, Icon }) => {
          const isActive = location.pathname === path;
          return (
            <Link
              key={path}
              to={path}
              className={`flex items-center gap-3 px-6 cursor-pointer ${
                isActive
                  ? "text-[#de2b26] font-medium"
                  : "text-[#142b70]/80 hover:text-[#de2b26]"
              }`}
            >
              <Icon
                color={isActive ? "#de2b26" : "#142b70"}
                iconClass="w-5 h-5 flex-shrink-0"
              />
              <span className="text-sm">{label}</span>
            </Link>
          );
        })}
      </div>

      {/* Logout at bottom */}
      <div
        className="mt-auto flex items-center gap-2 px-6 py-4 border-t border-[#142b701a] cursor-pointer"
        onClick={handleLogout}
      >
        <LogoutIcon iconClass="w-6 h-6 flex-shrink-0" color="#de2b26" />
        <p className="text-sm font-medium text-[#de2b26]">Logout</p>
      </div>
    </div>
  );
};

export default SideMenu;
